import React, { useEffect, useState } from 'react'
import {
  Box,
  Button,
  Grid,
  makeStyles,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core'
import {
  StyledTableCellBody,
  StyledTableCellHeader,
} from '../../../../components/hooks/BaseTableComponents'
import { CustomCheckbox } from '../../../../components/ui/custom-checkbox'
import { usePermissions } from '../../../../hooks/usePermission'
import { useDispatch, useSelector } from 'react-redux'
import filterStylesComponents from '../../../../assets/filterComponentsStyles'
import { syncUserPermissions } from '../../UserActions'

export const RoleAccesss = () => {
  const styles = filterStylesComponents()
  const dispatch = useDispatch()

  const { hasPermission, canRead, canCreate, canDelete, canUpdate } =
    usePermissions()

  const structure = useSelector(state => state.user.permissionStructure)
  const user = useSelector(state => state.user.editingUser)

  const [userPermissions, setUserPermissions] = useState([])
  const [addedPermissions, setAddedPermissions] = useState([])
  const [removedPermissions, setRemovedPermissions] = useState([])

  const initUserPermissions = () => {
    setUserPermissions(user?.permissions)
  }

  const syncUserPermission = permission => {
    const inUserPerms = userPermissions?.findIndex(
      perm => perm?.name === permission
    )

    if (inUserPerms > -1) {
      // Desmarcando: remove do visual
      setUserPermissions(prev =>
        prev.filter((_, index) => index !== inUserPerms)
      )

      // Se estava em addedPermissions, apenas remove de lá
      const wasAdded = addedPermissions?.some(perm => perm?.name === permission)
      if (wasAdded) {
        setAddedPermissions(prev =>
          prev.filter(perm => perm?.name !== permission)
        )
      } else {
        // Era uma permissão original do usuário, adiciona em removedPermissions
        setRemovedPermissions(prev => [...prev, { name: permission }])
      }
    } else {
      // Marcando: adiciona no visual
      setUserPermissions(prev => [...prev, { name: permission }])

      // Se estava em removedPermissions, apenas remove de lá
      const wasRemoved = removedPermissions?.some(
        perm => perm?.name === permission
      )
      if (wasRemoved) {
        setRemovedPermissions(prev =>
          prev.filter(perm => perm?.name !== permission)
        )
      } else {
        // É uma permissão nova, adiciona em addedPermissions
        setAddedPermissions(prev => [...prev, { name: permission }])
      }
    }
  }

  const handleSyncPermissions = () => {
    if (!addedPermissions?.length && !removedPermissions?.length) return
    dispatch(
      syncUserPermissions(user?.id, addedPermissions, removedPermissions)
    )
    setAddedPermissions([])
    setRemovedPermissions([])
  }

  useEffect(() => {
    if (!user?.permissions) return
    initUserPermissions()
  }, [user])

  return (
    <Box
      style={{
        flex: 1,
        gap: '4px',
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'flex-end',
        flexDirection: 'column',
      }}
    >
      <TableContainer
        style={{
          maxHeight: 'calc(100vh - 292px)',
          height: '100%',
        }}
      >
        <Table stickyHeader size="medium">
          <TableHead>
            <TableRow>
              <StyledTableCellHeader style={{ padding: '16px' }}>
                <Box style={{ display: 'flex', alignItems: 'center' }}>
                  <CustomCheckbox disabled style={{ marginRight: 10 }} />
                  Módulo
                </Box>
              </StyledTableCellHeader>
              <StyledTableCellHeader>
                <Box style={{ display: 'flex', alignItems: 'center' }}>
                  <CustomCheckbox disabled style={{ marginRight: 6 }} />
                  Criar
                </Box>
              </StyledTableCellHeader>
              <StyledTableCellHeader>
                <Box style={{ display: 'flex', alignItems: 'center' }}>
                  <CustomCheckbox disabled style={{ marginRight: 6 }} />
                  Visualizar
                </Box>
              </StyledTableCellHeader>
              <StyledTableCellHeader>
                <Box style={{ display: 'flex', alignItems: 'center' }}>
                  <CustomCheckbox disabled style={{ marginRight: 6 }} />
                  Atualizar
                </Box>
              </StyledTableCellHeader>
              <StyledTableCellHeader>
                <Box style={{ display: 'flex', alignItems: 'center' }}>
                  <CustomCheckbox disabled style={{ marginRight: 6 }} />
                  Deletar
                </Box>
              </StyledTableCellHeader>
            </TableRow>
          </TableHead>
          <TableBody>
            {structure?.map(permission => (
              <TableRow hover index={`permission-index-${permission.key}`}>
                <StyledTableCellBody style={{ padding: '16px' }}>
                  <Box style={{ display: 'flex', alignItems: 'center' }}>
                    <CustomCheckbox disabled style={{ marginRight: 10 }} />
                    {permission?.label}
                  </Box>
                </StyledTableCellBody>
                {permission?.permissions?.includes('create') ? (
                  <StyledTableCellBody>
                    <CustomCheckbox
                      checked={canCreate(permission.key, userPermissions)}
                      onChange={() =>
                        syncUserPermission(`create-${permission.key}`)
                      }
                      style={{ marginRight: 6 }}
                    />
                  </StyledTableCellBody>
                ) : (
                  <StyledTableCellBody></StyledTableCellBody>
                )}

                {permission?.permissions?.includes('read') ? (
                  <StyledTableCellBody>
                    <CustomCheckbox
                      checked={canRead(permission.key, userPermissions)}
                      onChange={() =>
                        syncUserPermission(`read-${permission.key}`)
                      }
                      style={{ marginRight: 6 }}
                    />
                  </StyledTableCellBody>
                ) : (
                  <StyledTableCellBody></StyledTableCellBody>
                )}

                {permission?.permissions?.includes('update') ? (
                  <StyledTableCellBody>
                    <CustomCheckbox
                      checked={canUpdate(permission.key, userPermissions)}
                      onChange={() =>
                        syncUserPermission(`update-${permission.key}`)
                      }
                      style={{ marginRight: 6 }}
                    />
                  </StyledTableCellBody>
                ) : (
                  <StyledTableCellBody></StyledTableCellBody>
                )}

                {permission?.permissions?.includes('delete') ? (
                  <StyledTableCellBody>
                    <CustomCheckbox
                      checked={canDelete(permission.key, userPermissions)}
                      onChange={() =>
                        syncUserPermission(`delete-${permission.key}`)
                      }
                      style={{ marginRight: 6 }}
                    />
                  </StyledTableCellBody>
                ) : (
                  <StyledTableCellBody></StyledTableCellBody>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Button className={styles.btnSalvar} onClick={handleSyncPermissions}>
        Salvar
      </Button>
    </Box>
  )
}
